import React, { useState } from 'react'
import { Box, Tooltip, IconButton } from '@material-ui/core'
import Timeline from '@material-ui/lab/Timeline'
import TimelineItem from '@material-ui/lab/TimelineItem'
import TimelineSeparator from '@material-ui/lab/TimelineSeparator'
import TimelineConnector from '@material-ui/lab/TimelineConnector'
import TimelineContent from '@material-ui/lab/TimelineContent'
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent'
import TimelineDot from '@material-ui/lab/TimelineDot'
import Paper from '@material-ui/core/Paper'
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons'
import Typography from '@material-ui/core/Typography'
import converDate from '../../../../utils/formatDate'
import useStyles from './styles'

const TimeLine = ({ userInfo }) => {
  const [selected, setSelected]= useState(null)
  const classes = useStyles();
  const expandCard = (index) => {
    setSelected(index)
  }
  return (
    <Timeline align="alternate">
      {userInfo.map((item, index) => (
        <TimelineItem key={`item${index}`}>
          <TimelineOppositeContent>
            <Typography
              variant="body2"
              color="textSecondary"
              className={classes.dates}
            >
              {item?.date ? converDate(item.date) : null}
            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot style={{ backgroundColor: item.color }} />
            <TimelineConnector style={{ backgroundColor: item.color }} />
          </TimelineSeparator>
          <TimelineContent>
            <Paper
              elevation={3}
              className={classes.paper}
              style={{
                border: `1.4px solid ${item.color}`,
                height: selected===index ? null : '200px',
              }}
            >
              <Box className={classes.titleContainer}>
                <Typography className={classes.mainTitle}>
                  {item.tableName.replaceAll('_', ' ')}
                </Typography>

                <IconButton onClick={() => expandCard(index)}>
                  <Tooltip title="Expandir/Encoger">
                    {item.statusHeight ? <ArrowDropUp /> : <ArrowDropDown />}
                  </Tooltip>
                </IconButton>
              </Box>
              {Object.entries(item).map((title,newIndex) => (
                <Box className={classes.containers} key={`item${newIndex}${index}`}>
                  {title[0] === 'date' ||
                  title[0] === 'tableName' ||
                  title[0] === 'color' ||
                  title[0] === 'statusHeight' ||
                  title[0] === 'ListaEntrega' ||
                  title[0] === 'id' ? null : (
                    <>
                      <Typography className={classes.titles}>
                        {title[0]}
                      </Typography>
                      <Typography className={classes.description}>
                        {title[1]}
                      </Typography>
                    </>
                  )}
                </Box>
              ))}
            </Paper>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  )
}

export default TimeLine
